import { getFeatureFlags } from '@/engine/featureFlags/featureFlags.api'
import ENV from '@/engine/env/web.env'

export default async function featureFlagsInit () {
  ENV.featureFlags.active && (await getFeatureFlags())
}
